"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPickerFooter = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Icon_1 = require("../../Icon");
require("./index.scss");
const className = 'day-picker-footer';
const DayPickerFooter = (props) => {
    const { resetHidden, onClose, onResetClick } = props;
    return (react_1.default.createElement("div", { className: `${className}` },
        !resetHidden && (react_1.default.createElement("button", { className: `${className}__reset`, onClick: onResetClick },
            react_1.default.createElement(Icon_1.Icon, { name: 'cycle' }),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Input/Date/Range:Reset', defaultMessage: 'Reset' }))),
        react_1.default.createElement("button", { className: `${className}__close`, onClick: onClose },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Input/Date/Range:Close', defaultMessage: 'Close' }),
            react_1.default.createElement(Icon_1.Icon, { name: 'x' }))));
};
exports.DayPickerFooter = DayPickerFooter;
//# sourceMappingURL=index.js.map